import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n.jsx";
import { useAuth } from "../context/AuthContext";
import { Avatar } from "../components/EmployeeBits";
import { ShieldCheck, ShieldOff } from "lucide-react";

export default function BadgeResolve() {
  const { token } = useParams(); const nav = useNavigate();
  const { t, tn } = useI18n(); const { can } = useAuth();
  const [d, setD] = useState(null); const [err, setErr] = useState(null);
  useEffect(() => { api.get(`/badges/resolve/${token}`).then((r) => setD(r.data)).catch((e) => setErr(e.response?.status || 500)); }, [token]);
  if (err) return <div className="max-w-md mx-auto tactical-card p-6 text-center" data-testid="badge-resolve-error"><ShieldOff className="mx-auto text-[var(--red)]" /> {t("BADGE_NOT_FOUND")}</div>;
  if (!d) return null;
  const e = d.employee || {};
  return (
    <div className="max-w-md mx-auto space-y-3" data-testid="badge-resolve">
      <div className={`tactical-card p-4 flex items-center gap-3 border-2 ${d.valid ? "border-emerald-400" : "border-red-400"}`}>
        {d.valid ? <ShieldCheck className="text-emerald-600 shrink-0" size={32} /> : <ShieldOff className="text-[var(--red)] shrink-0" size={32} />}
        <div><div className="font-bold" data-testid="badge-valid">{d.valid ? t("badge_valid_ok") : t("badge_invalid")}</div><div className="text-xs text-[var(--text-3)]">{t(`badge_${d.badge.status}`)} · {d.badge.valid_from} – {d.badge.valid_to || "∞"}</div></div>
      </div>
      <div className="tactical-card p-4 flex items-center gap-3">
        <Avatar emp={{ ...e, id: e.id }} size={64} />
        <div className="min-w-0"><div className="font-display font-bold text-lg truncate" data-testid="badge-emp-name">{e.name}</div><div className="text-sm text-[var(--text-3)]">{tn(e.position?.name) || "—"}</div><div className="font-mono-num text-sm">№ {e.employee_number}</div></div>
      </div>
      {can("employees.view") && e.id && <button onClick={() => nav(`/employees/${e.id}`)} className="text-sm text-[var(--blue)] underline" data-testid="badge-open-card">{t("open_employee_card")}</button>}
    </div>
  );
}
